import { render, staticRenderFns } from "./BankDataProfile.vue?vue&type=template&id=f78f8a30&scoped=true"
import script from "./BankDataProfile.vue?vue&type=script&lang=js"
export * from "./BankDataProfile.vue?vue&type=script&lang=js"
import style0 from "./BankDataProfile.vue?vue&type=style&index=0&id=f78f8a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78f8a30",
  null
  
)

export default component.exports